var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"star-btn",attrs:{"aria-label":_vm.ariaCopy},on:{"click":_vm.onClick,"mouseenter":_vm.onMouseEnter,"focus":_vm.onFocus}},[_c('star-svg')],1)}
var staticRenderFns = []

export { render, staticRenderFns }